// IBAN mod-97 validator. Accepts any ISO country; returns normalized (uppercase, no spaces) on ok.
export function normalizeAndValidateIban(raw: string): string {
  const cleaned = raw.replace(/\s+/g, '').toUpperCase();
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/.test(cleaned)) {
    throw new Error('Invalid IBAN format');
  }
  // Move first 4 chars to end, then convert letters to digits (A=10, B=11, …)
  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);
  let numeric = '';
  for (const ch of rearranged) {
    if (ch >= '0' && ch <= '9') numeric += ch;
    else numeric += (ch.charCodeAt(0) - 55).toString();
  }
  // Compute mod 97 piecewise to avoid BigInt overhead.
  let remainder = 0;
  for (let i = 0; i < numeric.length; i += 7) {
    const chunk = remainder.toString() + numeric.slice(i, i + 7);
    remainder = Number(chunk) % 97;
  }
  if (remainder !== 1) throw new Error('Invalid IBAN checksum');
  return cleaned;
}
